import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { myProjectSortOptions } from '../../react-query/project/query/use-get-my-projects-query'

export const useProjectMenuStore = create(
  persist(
    (set) => ({
      pageTitle: null,
      setPageTitle: (pageTitle) => set({ pageTitle }),

      tileViewFolderHistory: [],
      setTileViewFolderHistory: (tileViewCurrentFolder) =>
        set({ tileViewFolderHistory: tileViewCurrentFolder }),

      projectMenuSearch: '',
      setProjectMenuSearch: (projectMenuSearch) => set({ projectMenuSearch }),

      companyProjectsShowInactive: false,
      setCompanyProjectsShowInactive: (companyProjectsShowInactive) =>
        set({ companyProjectsShowInactive }),

      projectListPageSize: 15,
      setProjectListPageSize: (projectListPageSize) =>
        set({ projectListPageSize }),

      projectListPageNumber: 0,
      setProjectListPageNumber: (projectListPageNumber) =>
        set({ projectListPageNumber }),

      myProjectsSorting: [
        { id: myProjectSortOptions.LAST_MODIFIED, desc: true }
      ],
      setMyProjectsSorting: (myProjectsSorting) => set({ myProjectsSorting })
    }),

    {
      name: 'project-menu-store',
      partialize: (state) => ({
        projectListPageSize: state.projectListPageSize
      })
    }
  )
)
